import { render } from "./ProductEntry.vue?vue&type=template&id=8ba8e258&scoped=true"
import script from "./ProductEntry.vue?vue&type=script&lang=js"
export * from "./ProductEntry.vue?vue&type=script&lang=js"

import "./ProductEntry.vue?vue&type=style&index=0&id=8ba8e258&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba8e258"]])

export default __exports__